import { useWallet } from "@solana/wallet-adapter-react";
import {
  WalletModalButton,
  WalletModalProvider,
} from "@solana/wallet-adapter-react-ui";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";

import { verifyEmailRequest } from "../../api/users.api";
import { HOME } from "../../common/constants/routes.constants";
import Spinner from "../../components/Spinner/Spinner";
import { UserContext } from "../../contexts/userContext";
import "./EmailVerification.scss";

const EmailVerification = () => {
  const { publicKey } = useWallet();
  const params = useParams();
  const [emailVerified, toggleEmailVerification] = useState(false);
  const [loading, toggleLoading] = useState(false);
  const navigate = useNavigate();
  const { updateUser } = useContext(UserContext);

  useEffect(() => {
    if (publicKey) {
      void checkEmailVerification();
    }
  }, [publicKey]);

  const checkEmailVerification = async () => {
    toggleLoading(true);
    try {
      const emailVerificationDto = {
        pubKey: publicKey?.toString(),
      };
      const updatedUser = await verifyEmailRequest(
        emailVerificationDto,
        params.verificationId!
      );
      updateUser(updatedUser);
      toggleEmailVerification(true);
    } catch (error) {
      toggleEmailVerification(false);
    } finally {
      toggleLoading(false);
    }
  };

  if (loading) {
    return <Spinner isLoading={loading} />;
  }

  return (
    <WalletModalProvider>
      <div className="email-modal">
        <div className="email-modal__content">
          {!publicKey && (
            <div>
              <h3>Connect wallet to verify!</h3>
              <p>
                Please connect your wallet in order to verify your email address
              </p>
              <WalletModalButton
                className="email-modal__wallet-button"
                children={"Connect wallet"}
              />
            </div>
          )}
          {publicKey && emailVerified && (
            <div>
              <h3>Email successfully verified!</h3>
              <p>
                Congratulations! You have successfully verified your email
                address.
              </p>
              <button onClick={() => navigate(HOME)}>
                Proceed to Homepage
              </button>
            </div>
          )}
          {publicKey && !emailVerified && (
            <div>
              <h3>Verification link not found!</h3>
              <p>
                Verification link not found. Please check if you selected the
                right wallet for verification and try again.
              </p>
              <button onClick={() => navigate(HOME)}>
                Proceed to Homepage
              </button>
            </div>
          )}
        </div>
      </div>
    </WalletModalProvider>
  );
};

export default EmailVerification;
